import { render, staticRenderFns } from "./delegation.vue?vue&type=template&id=b1ba8dca"
import script from "./delegation.vue?vue&type=script&lang=js"
export * from "./delegation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports